// src/pages/docs/custom/setting.jsx
import { Typography, Box, Link, Button} from '@mui/material';
import DocsLayout from 'layout/DocsLayout';
import commandList from 'data/commands';
import { useLocation } from 'react-router-dom';
import { getAdjacentCommands } from 'components/getAdjacentCommands';

const CustomSettingCommand = () => {
  const location = useLocation();
  const command = commandList.find((cmd) => cmd.path === location.pathname);
  const { prev, next } = getAdjacentCommands(location.pathname);
  return (
    <DocsLayout>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, flexWrap: 'wrap', maxWidth: 800 }}>
        {/* 왼쪽 텍스트 영역 */}
        <Box sx={{ flex: 1, minWidth: 260 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            {"/커스텀 설정"}
          </Typography>
          <Typography variant="body1" sx={{ mt: -2, mb: 3 }}>
          {command?.description ?? '설명이 없습니다.'}
          </Typography>
          <Typography variant="h6">
            {"사용법: /커스텀 설정"}
          </Typography>
          <Typography variant="h6" fontWeight="bold" gutterBottom sx={{mt:3}}>
            {"프로필 사진 링크 넣는법"}
          </Typography>
          <Typography variant="body1" sx={{mt:-1}}>
            <Link href="https://imgur.com/upload" target="_blank" rel="noopener noreferrer">
                https://imgur.com/upload
            </Link><br />
          1. imgur 링크로 이동해 사진을 업로드합니다.<br />
          2. 업로드가 완료되면, 사진 우클릭 후 이미지 주소 복사를 선택합니다.<br />
          3. 디스코드로 돌아와서 프사변경에 붙여넣기 합니다.<br />
          {"<주의사항> 주소는 https://i.imgur.com/xxxxx 형식이어야 합니다. 아닐 시 다시 복사, 붙여넣기 합니다."}
          </Typography>          
        </Box>


        {/* 오른쪽 이미지 영역 */}
        <Box
          component="img"
          src="/commands/customsetting.webp"
          alt="설명 이미지"
          sx={{
            width: '100%',
            maxWidth: 400,
            borderRadius: 2,
            flexShrink: 0,
            mx: 'auto',
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'space-between' },
            gap: 4,
            width: { xs: '100%',md: 'auto' },
          }}
        >
        {prev && (
          <Button href={prev.path} variant="outlined"sx={{height: 36, width:118 }}>
            ← {prev.name}
          </Button>
        )}
        {next && (
          <Button href={next.path} variant="outlined"sx={{height: 36, width:118 }}>
            {next.name} →
          </Button>
        )}
        </Box>
      </Box>
    </DocsLayout>
  );
};

export default CustomSettingCommand;
